import $ from 'domtastic';
import anime from 'animejs';
import dropslideItem from './markup/dropslideItem';
import { events } from '../utils';

class Dropslide {
  constructor() {
    events.on('mobilenavopen', (event) => {
      if (!$('.js-dropdown-content')[0]) return;
      this.cacheDom();
      this.bindEvents();
      this.init(event.first);
    });
  }

  cacheDom() {
    this.$menu = $('.js-dropslide-menu');
    this.$initial = $('.js-dropslide-initial');
    this.$from = this.$menu.find('.js-dropslide-from');
    this.$to = this.$menu.find('.js-dropslide-to');
    this.$slides = this.$menu.find('.js-dropslide-slide');
    this.$back = this.$menu.find('.js-dropslide-back');
  }

  bindEvents() {
    this.$menu.on('click', '.js-dropslide-invoker', (event) => {
      event.preventDefault();
      this.handleForwardInvoker(event.target);
    });

    this.$back.on('click', (event) => {
      event.preventDefault();
      this.handleBackInvoker(event.target);
    });
  }

  init(firstOpen) {
    this.data = window.mobileNav;
    this.dataFlat = window.mobileNavFlat;
    if (firstOpen) this.$initialClone = this.$initial.clone();

    this.setFromInitial();

    let $dropdown;

    if (!firstOpen) $dropdown = $('.js-mobile-nav-dropdown');
    if (firstOpen) $dropdown = this.$initialClone.find('.js-mobile-nav-dropdown');
    $dropdown.toggleClass('-active', firstOpen);
    const height = $('.js-dropdown-content')[0].offsetHeight;
    $dropdown.css('height', `${firstOpen ? height : 0}px`);
  }

  handleForwardInvoker(invoker) {
    if (this.animating) return;
    const $invoker = $(invoker);
    const slug = $invoker.data('slug');
    this.setBackButtonSlug(slug);
    this.setToPositionX(1);
    this.setToContent(slug);
    this.animating = true;
    this.animate(1);
  }

  handleBackInvoker(invoker) {
    if (this.animating) return;
    const $invoker = $(invoker);
    const slug = $invoker.data('slug');
    this.setBackButtonSlug(slug);
    this.setToPositionX(0);
    this.setToContent(slug);
    this.animating = true;
    this.animate(0);
  }

  setBackButtonSlug(fromSlug) {
    const parentSlug = this.dataFlat[fromSlug] ? this.dataFlat[fromSlug].parent : '';
    this.$back.data('slug', parentSlug);
  }

  // Sets the from element to the initial navigation markup and "replaces" it
  setFromInitial() {
    this.$from.html(this.$initialClone.html());
    this.$initial.addClass('-hidden');
    this.$initial.html('');
    events.emit('dropslideload', true);
  }

  // 1 = right, 0 = left
  setToPositionX(direction = 0) {
    this.toInitialPosition = direction === 1 ? '100%' : '-100%';
    this.$to.removeClass('-right -left')
      .addClass(direction === 1 ? '-right' : '-left');
  }

  // Sets the markup content by slug
  setToContent(slug) {
    let markup = '';
    let toInitial = false;

    if (slug && slug !== 'false') { // Has parent level
      this.dataFlat[slug].children.forEach((child) => {
        markup += dropslideItem.create(child);
      });
      this.toggleBackButton(true);
    } else { // Doesn't have parent level
      toInitial = true;
      this.toggleBackButton(false);
      markup += this.$initialClone.html();
    }

    const $markup = $(markup);
    this.$to.html('').append($markup.clone());
    if (toInitial) events.emit('dropslideload', true);
  }

  // 1 = forward, 0 = back
  animate(direction = 0) {
    const forward = direction === 1;

    anime({
      targets: this.$from[0],
      translateX: [
        { value: forward ? [0, '-100%'] : [0, '100%'], duration: 300 },
      ],
      opacity: [
        { value: [1, 0], duration: 200, delay: 100 },
      ],
      easing: 'easeOutSine',
    })
      .finished.then(() => {
        this.$from.css('opacity', '1');
        this.animating = false;
      });

    anime({
      targets: this.$to[0],
      translateX: [
        { value: [this.toInitialPosition, '0%'], duration: 300 },
      ],
      easing: 'easeOutSine',
    })
      .finished.then(() => {
        this.switch();
        this.animating = false;
      });
  }

  switch() {
    this.$from.removeClass('js-dropslide-from');
    this.$from.addClass('js-dropslide-to');

    this.$to.removeClass('js-dropslide-to');
    this.$to.addClass('js-dropslide-from');

    this.cacheDom();
  }

  toggleBackButton(shouldShow) {
    this.$back.toggleClass('-visible', shouldShow);
  }
}

export default new Dropslide();



// WEBPACK FOOTER //
// ./components/Dropslide.js